import ApiBase from './base/ApiBase'
import { BaseEntity, ProcessType } from '../models/dtos';
import { ApiResponseContent } from '../models/custom-models';
import { ProficiencyGroupType } from '../Enums';

class TemplateClient extends ApiBase {
    private controllerName: string = 'Template';

    async Copy(id: string, ctx: CopyTemplate, signal?: AbortSignal): Promise<string> {
        return this.PostAsync(`${this.controllerName}/${id}/Copy`, ctx, signal);
    }

    async Create(dto: CreateTemplate, signal?: AbortSignal): Promise<string> {
        return this.PostAsync(`${this.controllerName}`, dto, signal);
    }

    async CreateTemplateWithUploadProficiencies(dto: string, signal?: AbortSignal): Promise<ApiResponseContent<string>> {
        return this.PostAsync(`${this.controllerName}/WithUploadProficiencies`, dto, signal);
    }


    async Delete(templateId: string, signal?: AbortSignal): Promise<void> {
        return this.DeleteAsync(`${this.controllerName}/${templateId}`, signal);
    }

    async GetSingle(id: string, signal?: AbortSignal): Promise<Template> {
        return this.GetAsync(`${this.controllerName}/${id}`, signal);
    }

    async GetSingleForTalent(talentId: string, signal?: AbortSignal): Promise<Template> {
        return this.GetAsync(`${this.controllerName}/Talent/${talentId}`, signal);
    }

    async GetAll(signal?: AbortSignal): Promise<Template[]> {
        return this.GetAsync(`${this.controllerName}`, signal);
    }

    async GetAllDisplay(signal?: AbortSignal): Promise<TemplateDisplay[]> {
        return this.GetAsync(`${this.controllerName}/Display`, signal);
    }

    async Update(templateId: string, name: string, signal?: AbortSignal): Promise<void> {
        return this.PutAsync(`${this.controllerName}/${templateId}`, name, signal);
    }
}

export interface CopyTemplate{
    PositionId: string;
    TemplateName: string;
}

export interface CreateTemplate{
    Process: ProcessType;
    PositionId: string;
    Name: string;
}

export interface ITemplate extends BaseEntity {
    Name: string;
    TemplateRevisionId: string;
    Revision: number;
    PositionId: string;
    ProcessType: ProcessType;
    IsActive: boolean;
}
export interface Template extends ITemplate {
    TemplateRevisionId: string;
    Revision: number;
    PositionId: string;
    ProcessType: ProcessType;
    Name: string;
    IsActive: boolean;
}

export interface TemplateRevision extends BaseEntity {
    TemplateId: string;
    PositionId: string;
    Revision: number;
    IsActive: boolean;
}

export interface TemplateDisplay extends Template {
    ActiveStatus: string;
    TemplateRevision: TemplateRevision;
}

export interface TemplateWithUploadProficiencies {
    Name: string;
    PositionId: string;
    ProcessType: ProcessType;
    UploadProficiencies: UploadProficiencyGroup[];
}

export interface UploadProficiencyItem {
    Description: string,
    Type: string,
    Weight: 0,
}

export interface UploadProficiencyGroup {
    ProficiencyGroup: ProficiencyGroupType,
    Proficiencies: UploadProficiencyItem[]
}

export enum TemplateErrors {
    Copy = 'Error copying template',
    Create = 'Error creating template',
    Delete = 'Error deleting template',
    GetSingle = 'Error loading template',
    GetAll = 'Error loading templates',
    Update = 'Error saving template',
    Publish = 'Error publishing Template',
    Generate = 'Error generating Template'
}

export default TemplateClient;
